import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';
import { Text } from '.';

const Secret = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    state = {
      hidden: true
    };

    toggleHidden = () => {
      this.setState({ hidden: !this.state.hidden });
    };

    render() {
      const { field, messages, placeholder, style, theme } = this.props;
      const { hidden } = this.state;

      return (
        <div className="secret" style={style}>
          <Text
            field={field}
            inputStyle={{ paddingRight: 40 }}
            placeholder={placeholder}
            type={hidden ? 'password' : 'text'}
          />

          <button
            aria-label={hidden ? messages.commonUnhide : messages.commonHide}
            className="toggle"
            data-tooltip={hidden ? messages.commonUnhide : messages.commonHide}
            onClick={this.toggleHidden}
            type="button"
          >
            <Icon icon={hidden ? 'eye' : 'eye-slash'} />
          </button>

          <style jsx>{`
            .secret {
              position: relative;
            }
            .toggle {
              background-color: transparent;
              border: 0;
              color: ${theme.textColorLighter};
              cursor: pointer;
              font-size: 1.4rem;
              outline: 0;
              position: absolute;
              text-align: center;
              transition: color 0.3s;
              top: 2px;
              right: 2px;
              bottom: 2px;
              width: 34px;
            }
            .toggle:focus,
            .toggle:hover {
              color: ${theme.textColorLight};
            }
          `}</style>
        </div>
      );
    }
  }
);

export default Secret;
